import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/auth";
import "firebase/compat/database";
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import * as App from "./../../App";

type DocumentData = firebase.firestore.DocumentData;

//
// Firebase WRITE API
//

//
// TRADEMARKS
//

export async function createTrademark(userID: string, trademark: App.Data.App.ITrademark): Promise<string | null> {
    const ref = firebase.database().ref(`/trademarks/${userID}`);
    const tm = await ref.push(trademark);
    return tm.key;
}

export async function updateTrademark(userID: string, trademarkID: string, trademark: App.Data.App.ITrademark): Promise<void> {
    // If anything is undefined, change to null so Firebase doesn't cause problems...
    Object.keys(trademark).forEach((key: string) => {
        if ((trademark as any)[key] === undefined) {
            (trademark as any)[key] = null;
        }
    });

    const ref = firebase.database().ref(`/trademarks/${userID}/${trademarkID}`);
    await ref.update(trademark);
}

export async function deleteTrademark(userID: string, trademarkID: string): Promise<void> {
    const ref = firebase.database().ref(`/trademarks/${userID}/${trademarkID}`);
    await ref.remove();
}

//
// PATENTS
//

export async function createPatent(userID: string, patent: App.Data.App.IPatent): Promise<string | null> {
    const ref = firebase.database().ref(`/patents/${userID}`);
    const tm = await ref.push(patent);
    return tm.key;
}

export async function updatePatent(userID: string, patentID: string, patent: App.Data.App.IPatent): Promise<void> {
    console.log("Updating", patentID, patent);

    const ref = firebase.database().ref(`/patents/${userID}/${patentID}`);
    await ref.update(patent);
}

export async function deletePatent(userID: string, patentID: string): Promise<void> {
    const ref = firebase.database().ref(`/patents/${userID}/${patentID}`);
    await ref.remove();
}

//
// CLIENTS
//

export async function createClient(userID: string, client: App.Data.App.IClient): Promise<string | null> {
    const ref = firebase.database().ref(`/clients/${userID}`);
    const c = await ref.push(client);
    return c.key;
}

export async function updateClient(userID: string, clientId: string, client: App.Data.App.IClient): Promise<void> {
    console.log("Updating client", clientId, client);
    const ref = firebase.database().ref(`/clients/${userID}/${clientId}`);
    await ref.update(client);
}

// TODO: Need to delete from all patents/trademarks referencing this client
export async function deleteClient(userID: string, clientId: string): Promise<void> {
    const ref = firebase.database().ref(`/clients/${userID}/${clientId}`);
    await ref.remove();
}

//
// IMAGES
//

export async function uploadImage(userID: string, id: string, image: File): Promise<string | null> {
    let metadata = {};
    metadata = { contentType: "image/jpeg" }  // TODO: Is this ok?

    const stRef = firebase.storage().ref().child(`images/${userID}/${id}`);
    return stRef.put(image, metadata).then((snapshot: firebase.storage.UploadTaskSnapshot) => {
        return snapshot.ref.getDownloadURL();
    });
}

// Delete the image from storage. Does not delete any other references to the image.
export async function deleteImage(userID: string, imageID: string): Promise<void> {
        const stRef = firebase.storage().ref().child(`images/${userID}/${imageID}`);
        return stRef.delete()
            .catch((error: Error) => { });
}





/** Clears out all user data from the database (but only the /users node, not any references to that user) */
export async function clearUserData(userID: string): Promise<any> {
    var paths: { [key: string]: any } = {};
    paths["users/" + userID] = null;
    return firebase.database().ref().update(paths);
}

/** 
 * TODO: Param documentation
 * Updates the given user with the given data. If you want to delete a property, add it to data with a value of null. 
 * This should be used if you only want to update certain properties and leave everything else the same.
*/
export async function updateUserData(userID: string, userData: any, demographics: any): Promise<any> {  
    // Add each property individually so we don't overwrite any data...
    const paths: { [key: string]: any } = {};
    
    // users/{userID}/[...]...
    Object.keys(userData).forEach(function(dataKey: string) {
        paths["users/" + userID + "/" + dataKey] = userData[dataKey];
    });
    
    // users/{userID}/demographics/[...]...
    Object.keys(demographics).forEach(function(dataKey: string) {
      paths["users/" + userID + "/demographics/" + dataKey] = demographics[dataKey];
    });

    // Perform the update...
    return firebase.database().ref().update(paths);
}

export async function setUserDemographics(userID: string, demographics: App.Data.User.IUserDemographics): Promise<void> {
    return; // TODO:
}

export async function setUserApplicationSettings(userID: string, applicationSettings: App.Data.User.IApplicationSettings): Promise<void> {
    return; // TODO:
}

/**
 * Submits the given feedback for the current user
 * @param feedback Feedback from user
 */
export async function submitFeedback(feedback: string): Promise<firebase.firestore.DocumentReference<DocumentData>> {
    const today = new Date();
    const currentDate = today.getTime();
    const sCurrentDate = today.toLocaleDateString() + " " + today.toLocaleTimeString();
    const currentUser = firebase.auth().currentUser;
    const currentUID = (currentUser) ? currentUser.uid : "";
    const email = (currentUser) ? currentUser.email : "";

    return firebase.firestore().collection("feedback").add({
        date: currentDate,
        sDate: sCurrentDate,
        user: currentUID,
        email: email,
        feedback: feedback
    });
}